import { pipe, RA, O } from '@packages/prelude'
import * as domain from '@packages/domain'
import * as select from '~/selectors'
import { Configuration } from '~/store'

/**
 * Step resolution algorithm
 * Resolves next steps based on selected option's references and sequential flow
 */
export const resolveNextSteps = (
  currentStepId: domain.StepId.Type,
  selectedOption: domain.Option.Type,
  state: Configuration.State
): ReadonlyArray<domain.StepId.Type> => {
  // Get referenced steps (will be ordered by step ID naturally from data)
  const referencedSteps = selectedOption.referencedStepIds

  // Get next sequential step
  const nextSequentialStep = pipe(
    select.Configuration.getNextSequentialStep(currentStepId, state),
    O.map(stepId => [stepId]),
    O.getOrElse(() => [] as ReadonlyArray<domain.StepId.Type>)
  )

  // Combine and deduplicate
  return pipe(
    [referencedSteps, nextSequentialStep],
    RA.flatten,
    RA.uniq(domain.StepId.Eq)
    // No queue length restriction - support multiple optional steps
  )
}
